import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ArticleCard = ({ article, variant = 'default' }) => {
  if (variant === 'compact') {
    return (
      <div className="w-full max-w-full overflow-hidden">
        <div className="flex space-x-3 p-3 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
          <div className="flex-shrink-0">
            <Image
              src={article.image}
              alt={article.title}
              className="w-16 h-16 rounded-lg object-cover"
            />
          </div>
          <div className="flex-1 min-w-0 space-y-1.5">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 flex-shrink-0">
                {article.category}
              </span>
              <span className="text-xs text-gray-600 flex-shrink-0">
                {article.readTime}m
              </span>
            </div>
            <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 leading-tight pr-2">
              {article.title}
            </h3>
            <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed pr-2">
              {article.excerpt}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-text-secondary truncate pr-2">
                {article.publishDate}
              </span>
              <Link
                to={`/insights-blog/${article.slug}`}
                className="text-blue-600 hover:text-blue-800 transition-colors duration-200 flex-shrink-0"
                title="Read article"
              >
                <Icon name="ArrowRight" size={12} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
      <div className="relative h-48 overflow-hidden">
        <Image
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover"
        />
        {article.trending && (
          <div className="absolute top-3 right-3">
            <div className="flex items-center space-x-1 px-2 py-1 bg-red-500 text-white rounded-full text-xs font-medium">
              <Icon name="TrendingUp" size={12} />
              <span>Trending</span>
            </div>
          </div>
        )}
      </div>

      <div className="p-6">
        <div className="flex items-center space-x-3 mb-3">
          <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
            {article.category}
          </span>
          <span className="text-sm text-gray-600">
            {article.readTime} min read
          </span>
        </div>

        <h3 className="text-lg font-bold font-heading text-gray-900 mb-3 line-clamp-2">
          {article.title}
        </h3>

        <p className="text-gray-700 mb-4 line-clamp-3">
          {article.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Image
              src={article.author.avatar}
              alt={article.author.name}
              className="w-8 h-8 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-medium text-gray-900">
                {article.author.name}
              </p>
              <p className="text-xs text-gray-600">
                {article.publishDate}
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            {article.socialProof && (
              <div className="flex items-center space-x-1 text-white/70">
                <Icon name="Heart" size={14} />
                <span className="text-xs">{article.socialProof.likes}</span>
              </div>
            )}
            <Link
              to={`/insights-blog/${article.slug}`}
              className="inline-flex items-center space-x-1 text-brand-cyan hover:text-white transition-colors duration-200"
            >
              <span className="text-sm font-medium">Read</span>
              <Icon name="ArrowRight" size={14} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;